import { useState } from "react";
import { X, Stack } from "@phosphor-icons/react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { PricingRulesEditor, sanitizePricingRules, DEFAULT_WEEKEND } from "./PricingRulesEditor";

// Modal de edição de regras de preço EM MASSA (PUT /listings/bulk-rules). V12.4
export default function BulkRulesModal({ listingIds, onClose, onDone }) {
  const [value, setValue] = useState({ discount_rules: [], weekend_promo: { ...DEFAULT_WEEKEND }, quantity_discount_rules: [] });
  const [busy, setBusy] = useState(false);
  const n = listingIds.length;

  const submit = async () => {
    setBusy(true);
    try {
      const clean = sanitizePricingRules(value);
      const r = await api.put("/listings/bulk-rules", { item_ids: listingIds, ...clean });
      toast.success(`Regras aplicadas em ${r.data.updated} anúncio(s)!`);
      onDone?.();
      onClose?.();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-4 pb-safe" data-testid="bulk-rules-modal">
      <div className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl p-5 space-y-4 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between">
          <h2 className="font-heading font-black text-lg flex items-center gap-2"><Stack size={20} weight="fill" className="text-[#004E98]" /> Editar regras em massa</h2>
          <button onClick={onClose} className="p-1 text-slate-400" data-testid="bulk-rules-close"><X size={22} /></button>
        </div>
        <p className="text-xs text-slate-500">Estas regras vão <b>substituir</b> as regras atuais de <b>{n}</b> anúncio(s) selecionado(s).</p>

        <PricingRulesEditor value={value} onChange={setValue} unitLabel="dias" />

        <button onClick={submit} disabled={busy} className="btn-primary w-full disabled:opacity-50" data-testid="bulk-apply-btn">
          {busy ? "Aplicando..." : `Aplicar em ${n} anúncio(s)`}
        </button>
      </div>
    </div>
  );
}
